import { render } from "./ShopItem.vue?vue&type=template&id=6c22e3ce&scoped=true&ts=true"
import script from "./ShopItem.vue?vue&type=script&lang=ts"
export * from "./ShopItem.vue?vue&type=script&lang=ts"

import "./ShopItem.vue?vue&type=style&index=0&id=6c22e3ce&scoped=true&lang=css"

import exportComponent from "/Users/jonas/Developer/Fliegen/KantineV2/webapp/shop-webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c22e3ce"]])

export default __exports__